// limitation: this tabbing service does not work with 'tabindex' currently (though it's certainly possible to modify this class to accommodate tabindex if needed)

import { Injectable } from "@angular/core";

@Injectable({ providedIn: "root" })
export class TabTrapService {

    public settingsDefault: Object = {
        // whether to auto-focus to an element in the provided modal container (meant to trap tab events within this container)
        autoFocusEnabled: true,
        // sets the auto-focus to an element by this class name (requires 'autoFocusEnabled' to be set to 'true')
        autoFocusByClassName: ['modal-tab-trap-first-focus', 'Button--blue'],
        onCloseKeyCallback: undefined
    };
    public openModalData = [];

    constructor() {}

    init(settings?: Object) {
        this.settingsDefault = Object.assign({}, this.settingsDefault, settings);

        // TODO: Not sure if this is needed anymore
        // capture ngDialog open event
        // this.$rootScope.$on('ngDialog.opened', (e, $dialog) => {
        //     this.open(document.getElementById($dialog.attr('id')));
        // });
        // // capture ngDialog close event
        // this.$rootScope.$on('ngDialog.closed', (e, $dialog) => {
        //     this.close();
        // });
    }

    open(modalContainerOrListOfContainers: any, settings?: Object) {
        let settingsInstance = Object.assign({}, this.settingsDefault, settings);
        let focusableElements = [];
        let interactiveElementsQuery = 'a[href], area[href], input, select, textarea, button, iframe, object, embed, [tabindex="0"], [contenteditable]';
        let modalData = {
            removeListenerFunctions: []
        };

        this.openModalData.push(modalData);

        // delay 1 frame to allow angular to apply directives like 'ng-disabled' (this is critical for modals that have buttons that get toggled such as the date picker)
        setTimeout(
            () => {
                // if NOT an array / list of element containers to check within
                if (!Array.isArray(modalContainerOrListOfContainers)) {
                    // change to array with the single element container
                    modalContainerOrListOfContainers = [modalContainerOrListOfContainers];
                }

                // loop over all element containers
                for (let i = 0; i < modalContainerOrListOfContainers.length; i++) {
                    // add to the list of tab-able / interactive elements
                    focusableElements = focusableElements.concat(Array.prototype.slice.call(modalContainerOrListOfContainers[i].querySelectorAll(interactiveElementsQuery)));
                }

                // iterate over the list of tab-able / interactive elements in reverse
                for (let i = focusableElements.length - 1; i > -1; i--) {
                    // if element isn't visible
                    if (this.isHidden(focusableElements[i])) {
                        // remove hidden item from the list
                        focusableElements.splice(i, 1);
                    }
                }

                let firstItem = focusableElements[0];
                let lastItem = focusableElements[focusableElements.length - 1];
                let focusItem;

                // if auto focus to an element is enabled
                if (settingsInstance['autoFocusEnabled'] && focusableElements.length > 0) {
                    // if auto focus by class name is defined
                    if (settingsInstance['autoFocusByClassName']) {
                        let autoFocusByClassName;
                        let isFound = false;

                        for (let j = 0; j < settingsInstance['autoFocusByClassName'].length; j++) {
                            autoFocusByClassName = settingsInstance['autoFocusByClassName'][j];
                            for (let i = 0; i < focusableElements.length; i++) {
                                // if first focus element has been found and is not disabled
                                if (isFound === false && focusableElements[i].disabled !== true && this.hasClass(focusableElements[i], autoFocusByClassName)) {
                                    isFound = true;
                                    focusItem = focusableElements[i];
                                    break;
                                }
                            }
                        }
                    }

                    if (!focusItem) {
                        focusItem = firstItem;
                    }

                    focusItem.focus();
                }

                let keydownListener = (e: any) => {
                    if (e.keyCode === 9) {
                        // Shift Tab
                        if (e.shiftKey) {
                            e.preventDefault();
                            // set focus to the next available element (going in reverse)
                            this.getNextFocusElement(focusableElements, -1, null).focus();
                        }
                        // Else Tab
                        else {
                            e.preventDefault();
                            // set focus to the next available element (going in forward)
                            this.getNextFocusElement(focusableElements, 1, null).focus();
                        }
                    }
                    else if (e.keyCode === 27) {
                        if (settingsInstance['onCloseKeyCallback']) {
                            // @ts-ignore
                            settingsInstance.onCloseKeyCallback();
                        }
                    }
                };

                for (let k = 0; k < modalContainerOrListOfContainers.length; k++) {
                    modalContainerOrListOfContainers[k].addEventListener('keydown', keydownListener);
                    modalData.removeListenerFunctions.push(function () {
                        modalContainerOrListOfContainers[k].removeEventListener('keydown', keydownListener);
                    });
                }
            },
            0
        );
    }

    close() {
        let modalData = this.openModalData.pop();
        if (modalData) {
            for (var k = 0; k < modalData.removeListenerFunctions.length; k++) {
                // must remove listeners (the more menu is one obviously place that will go crazy if listeners not removed)
                modalData.removeListenerFunctions[k]();
            }
        }
    }

    hasClass(target, className) {
        return new RegExp('(\\s|^)' + className + '(\\s|$)').test(target.className);
    }

    isHidden(el) {
        // var style = window.getComputedStyle(el);
        // return (style.display === 'none')

        // Support: Opera <= 12.12
        // Opera reports offsetWidths and offsetHeights less than zero on some elements
        return el.offsetWidth <= 0 && el.offsetHeight <= 0;
    }

    getNextFocusElement(focusableElements, directionPlusMinus, currentFocusElement) {
        let isCurrentFound = false;
        let index;
        let flipLoopDirectionFactor = directionPlusMinus > 0 ? 0 : (focusableElements.length * 2) - 1;

        // optional
        currentFocusElement = currentFocusElement || document.activeElement;

        // iterate over the list of tab-able / interactive elements in reverse (double length because we might find the element at the end of the array in which case we'll want to iterate through the list again)
        for (let i = 0; i < focusableElements.length * 2; i++) {
            // flips the direction we iterate through the array if needed
            index = Math.abs(flipLoopDirectionFactor - i) % focusableElements.length;

            // if we haven't found the element to start search with
            if (isCurrentFound === false) {
                if (focusableElements[index] === currentFocusElement) {
                    isCurrentFound = true;
                    continue;
                }
            }
            else {
                // if element is visible and enabled
                if (!this.isHidden(focusableElements[index]) && !focusableElements[index].disabled) {
                    return focusableElements[index];
                }
            }
        }

        // if no element was returned (failsafe)
        return focusableElements[0];
    }
}

